import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { DienstleistungArtenService } from './dienstleistung-arten.service';
import { IDienstleistungArtInfo } from '@mng/mgs-lib';

export const dienstleistungArtenResolver: ResolveFn<IDienstleistungArtInfo[]> = async () => {
  const dienstleistungArtenService = inject(DienstleistungArtenService);
  return dienstleistungArtenService.initialize();
};
